import PrintWrapper from "@/components/PrintWrapper/PrintWrapper";
import PrintAuditStatus from "@/components/StatusAudit/PrintAuditStatus";
import React, { useEffect, useState } from "react";

function PrintAuditStatusPgae() {
  const [auditData, setData] = useState(null);

  useEffect(() => {
    const stored = localStorage.getItem("PRINT_AUDIT_DATA");
    if (stored) {
      setData(JSON.parse(stored));
    }
    return () => {
      localStorage.removeItem("PRINT_AUDIT_DATA");
    };
  }, []);

  return (
    <PrintWrapper title={`STATUS AUDIT`}>
      {auditData ? (
        <PrintAuditStatus data={auditData} />
      ) : (
        <div>
          <p className="text-center text-gray-500 text-lg mt-3">
            No Data Found
          </p>
        </div>
      )}
    </PrintWrapper>
  );
}

export default PrintAuditStatusPgae;
